<template>
    <div class="my-connections-list">
        <div class="tabcontent">
            <div class="my-connection-filters-invite">
                <div class="my-connection-filters">
                    <my-connections-list-filter v-show="showFilter" ref="myConnectionsListFilter"></my-connections-list-filter>
                </div>
                <div v-show="!connections.length" class="my-connections-list-message-box">
                    <div class="my-connections-list-message-text">
                        <p>
                            {{
                                isPhysicianTab
                                    ? $t('pages.network.connections.message_box.physicians')
                                    : $t('pages.network.connections.message_box.service_providers')
                            }}
                        </p>
                        <p>{{ $t('pages.network.connections.message_box.invite_partners') }}</p>
                    </div>
                    <common-icon name="arrow" size="extra-large"></common-icon>
                </div>
            </div>
            <div ref="tabsContainer" class="tabs-container">
                <common-grid>
                    <common-grid-column v-for="(conn, index) in connections" :key="index">
                        <practice-member-card
                            v-if="isPhysicianTab"
                            :physician="conn.user"
                            :showInvitedDate="true"
                            :showNewUserWarning="true"
                            :showNetworkInclusionStatus="true"
                            @checkAvailability="checkAvailability($event)"
                        ></practice-member-card>
                        <ancillary-member-card
                            v-else
                            :ancillary="conn.practice"
                            :showInvitedDate="true"
                            :showCardAvailability="!!conn.practice"
                            :showNetworkInclusionStatus="!!conn.createdDate"
                        ></ancillary-member-card>
                    </common-grid-column>
                </common-grid>
            </div>

            <div ref="viewMoreBtn" class="viewMoreButton">
                <common-button
                    v-show="showLoadMoreButton"
                    :isProcessing="isSending"
                    :label="'VIEW MORE'"
                    type="primary"
                    size="large"
                    @click="loadMore"
                ></common-button>
            </div>
        </div>
    </div>
</template>

<script>
    import PracticeMemberCard from 'components/page-elements/practice/PracticeMemberCard'
    import AncillaryMemberCard from 'components/page-elements/practice/AncillaryMemberCard'
    import ConnectionMixin from './../../../mixins/ConnectionMixin'
    import MyConnectionsListFilter from './MyConnectionsListFilter'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'
    import InviteByEnum from '@/enums/InviteByEnum'

    export default {
        mixins: [ConnectionMixin],
        components: {
            PracticeMemberCard,
            AncillaryMemberCard,
            MyConnectionsListFilter,
        },
        props: {
            connections: { type: Array, required: true },
            connectionDirection: { type: String, required: true },
            isPhysicianTab: { type: Boolean, required: true },
            orderBy: { type: String, default: 'NameASC' },
            totalCount: { type: Number, default: 0 },
        },
        data() {
            return {
                data: {
                    inviteBy: InviteByEnum.INVITE_BY_EMAIL,
                },
                limit: 10,
                offset: 0,
                lastFilter: {
                    orderBy: this.orderBy,
                    connectionDirection: this.connectionDirection,
                },
                showLoadMoreButton: false,
                showFilter: false,
                showMessageBox: false,
                isConnectionFilterAll: true,
                emailsCheck: {
                    invited: [],
                    registeredInvites: [],
                    registeredOther: [],
                    newInvitations: [],
                },
                invitePracticeType: '',
                isDropdownOpen: false,
                isSending: false,
            }
        },
        computed: {
            isAllFilterSelected() {
                return this.$route.query.status === 'all'
            },
            inviteButtonLabel() {
                return this.isPhysicianTab
                    ? 'pages.network.connections.buttons.invite_physician'
                    : 'pages.network.connections.buttons.invite_provider'
            },
        },
        methods: {
            toggleDropdown() {
                this.isDropdownOpen = !this.isDropdownOpen
            },
            closeDropdown() {
                this.isDropdownOpen = false
            },
            filterChanged(filter) {
                this.lastFilter.connectionDirection = filter.connectionDirection
                this.lastFilter.orderBy = filter.orderBy
                this.isConnectionFilterAll = filter.connectionDirection === 'All'

                this.fireFilterChanged()
            },
            fireFilterChanged() {
                let payload = {
                    connectionDirection: this.lastFilter.connectionDirection,
                    orderBy: this.lastFilter.orderBy,
                    limit: this.limit,
                    offset: this.offset,
                }

                this.$emit('filter-changed', payload)
            },
            loadMoreClicked() {
                this.offset = this.offset + this.limit

                this.fireFilterChanged()
            },
            checkAvailability(ev) {
                let isPhysician =
                    ev.target && ev.target.specialities && ev.target.specialities[0] && ev.target.specialities[0].subSpeciality

                let specialityId = isPhysician ? ev.target.specialities[0].speciality.id : null
                let subSpecialityId = isPhysician ? ev.target.specialities[0].subSpeciality.id : null

                let locations = ev.target && ev.target.practice && ev.target.practice.locations

                let locationZip = locations ? locations.find((loc) => loc.id == ev.practiceLocationId).zip : null

                let practiceType = isPhysician ? PracticeTypeEnum.PHYSICIAN : PracticeTypeEnum.ANCILLARY

                this.$router.push({
                    name: 'referrals.new.make',
                    query: {
                        userId: this.$auth.getActiveMember().id,
                        practiceType: practiceType,
                        searchBy: 'zipcode',
                        specialityId: specialityId,
                        subSpecialityId: subSpecialityId,
                        zip: locationZip,
                        physicianId: ev.physicianId,
                        practiceId: ev.practiceId,
                        practiceLocationId: ev.practiceLocationId,
                    },
                })
            },
            loadMore() {
                this.emitEvent({ name: 'load-more', payload: {} })
            },

            resetConnectionListFilter() {
                this.$refs.myConnectionsListFilter.resetFilter()
            },
        },

        watch: {
            connections() {
                this.showLoadMoreButton = this.totalCount > this.connections.length
                if (this.isAllFilterSelected) {
                    this.showFilter = this.totalCount > 0 || !this.isConnectionFilterAll
                    this.showMessageBox = !this.showFilter
                }
            },
        },

        mounted() {
            this.showLoadMoreButton = this.totalCount > this.connections.length
            if (this.isAllFilterSelected) {
                this.showFilter = this.totalCount > 0 || !this.isConnectionFilterAll
                this.showMessageBox = !this.showFilter
            }
        },
    }
</script>
